import { Formatter } from '@/filters/formatter'
import { Options, PointLabelObject, TooltipFormatterContextObject } from 'highcharts'

export const StatisticalAnalysisViewDetailChartTypeChartsFactoryColumn: Options = {
    chart: {
        type: 'column'
    },
    xAxis: {
        crosshair: true
    },
    yAxis: {
        min: 0
    },
    tooltip: {
        formatter: function() {
            const context: TooltipFormatterContextObject = this
            const points: TooltipFormatterContextObject[] = context.points!
            const header: string = `<span>${context.x}</span><br>`
            let series: string = ''
            points.forEach((point: TooltipFormatterContextObject) => {
                series += `<span style="color:${point.color}">${point.series.name}</span>: <b> ${Formatter.number(point.y)}</b><br/>`
            })
            return header + series
        },
        shared: true,
        useHTML: true
    },
    plotOptions: {
        column: {
            stacking: undefined,
            pointPadding: 0.2,
            borderWidth: 0,
            dataLabels: {
                enabled: true,
                formatter: function() {
                    const context: PointLabelObject = this
                    return `${Formatter.number(context.y)}`
                }
            }
        }
    }
}
